<div >
    <span *ngIf="validSuggestionLink" [accelaTooltip]="getSuggestionTooltip()" tooltipEvent="hover|focus" tooltipPosition="bottom" tabindex="0">    
        <i class="accelicons-link"></i><span class='relatedRecordsFound'>{{getAddressCardText()}}</span>
    </span>
    <span *ngIf="!validSuggestionLink">    
        <span>{{getAddressCardText()}}</span>
    </span>
    <div class="mc-card-item-actions">
        <span *ngIf="isPrimary()" class="mc-card-primary" i18n="(Primary Address) | Primary Address Label">(Primary Address)</span> <button *ngIf="!isPrimary()" pButton type="button" label="Make Primary" class="p-button-text" (click)="setToPrimary($event)"></button> | <button pButton type="button" label="View" class="p-button-text" (click)="showViewForm($event)"></button> | <button pButton type="button" label="Delete" class="p-button-text" (click)="deleteRecord($event)"></button>
    </div>
</div>
